import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

import {REDUX_FETCHING_STATES} from "../../constants";
import {shoppingCartActions, shoppingCartSelectors, shoppingCartState,} from "../../redux/shoppingCart.slice";

// Create a new cart with items

function useShoppingCart(id) {
    const dispatch = useDispatch()

    const {shoppingCartData, loading, error} = useSelector(shoppingCartState)
    const shoppingCartItems = useSelector(shoppingCartSelectors.shoppingCartItemsSelector)
    const shoppingCartItemsLength = useSelector(shoppingCartSelectors.shoppingCartItemsLengthSelector)
    const shoppingCartTotal = useSelector(shoppingCartSelectors.shoppingCartTotalSelector)
    const isShoppingCartTotalNil = Number(useSelector(shoppingCartSelectors.shoppingCartTotalSelector)) === 0
    const shoppingCartId = useSelector(shoppingCartSelectors.shoppingCartIdSelector)
    const shoppingCartClientToken = useSelector(shoppingCartSelectors.shoppingCartClientTokenSelector)
    const shoppingCartSubTotal = useSelector(shoppingCartSelectors.shoppingCartSubTotalSelector)
    const shoppingCartTaxesAndFees = useSelector(shoppingCartSelectors.shoppingCartTaxesAndFeesSelector)
    const shoppingCartDiscountAmount = useSelector(shoppingCartSelectors.shoppingCartDiscountAmountSelector)
    const isPaymentSuccessful = useSelector(shoppingCartSelectors.shoppingCartIsPaymentSuccessfulSelector)
    const isDraftShoppingCartUpdated = useSelector(shoppingCartSelectors.isDraftShoppingCartUpdatedSelector)


    const createNewCart = (items = []) => (async () => dispatch(shoppingCartActions.createShoppingCart(items)).unwrap())()

    const executeShoppingCart = ({
                                     nonce, email, firstName, lastName, phoneNumber, ...rest
                                 }) => (async () => {
        if (!nonce || !email || !firstName || !lastName || !phoneNumber) {
            if (!nonce) {
                console.debug('nonce not provided')
                throw new Error('Nonce not provided')
            }
            console.debug({email, firstName, lastName, phoneNumber})
            throw new Error('Shopping Cart is incomplete, please complete info.')
        } else {
            return dispatch(shoppingCartActions.executeShoppingCart({
                shoppingCartId: id || shoppingCartId,
                nonce, email, firstName, lastName, phoneNumber, ...rest
                // eslint-disable-next-line promise/always-return
            })).unwrap()
        }
        // setShoppingCart(cart)
    })()

    useEffect(() => {
        // If shopping cart ID has been passed, fetch that shopping cart and store in redux
        if (id) {
            (async () => {
                await dispatch(shoppingCartActions.fetchShoppingCart(id)).unwrap()
            })()
        }
    }, [dispatch, id])

    return {
        shoppingCartData,
        shoppingCartItems,
        shoppingCartItemsLength,
        isLoading: loading === REDUX_FETCHING_STATES.PENDING,
        error,
        createNewCart,
        shoppingCartTotal,
        shoppingCartSubTotal,
        shoppingCartTaxesAndFees,
        shoppingCartDiscountAmount,
        shoppingCartClientToken,
        executeShoppingCart,
        isPaymentSuccessful,
        shoppingCartId,
        isDraftShoppingCartUpdated,
        isShoppingCartTotalNil,
    }
}

export default useShoppingCart
